import { render, staticRenderFns } from "./SourceVideoView.vue?vue&type=template&id=7565578a&scoped=true&"
import script from "./SourceVideoView.vue?vue&type=script&lang=js&"
export * from "./SourceVideoView.vue?vue&type=script&lang=js&"
import style0 from "./SourceVideoView.vue?vue&type=style&index=0&id=7565578a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7565578a",
  null
  
)

export default component.exports